import SC from "./style";
import { useEffect, useState } from "react";
import { Button, Label } from "InnoUI/components";
import theme from "@theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { FolderTypeDropdown, InputField } from "components";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@mui/material";
import { privacyOption } from "utils/optionData/utils";
import { apiPost } from "api/callApi";
import { regexTypes } from "utils/config";
import { isEmpty, showAlert } from "utils/helper";
import SmartFolderColumnDropdown from "components/SmartFolderColumnDropdown";
import { allFolderType } from "utils/lookUpTable";

function AddEditFolder(props) {
  const {
    isEditing,
    setOpenModalView,
    setIsEditing,
    openModalView,
    folderData,
    setModalRowData,
    parentId = null,
    templateId,
    fetchData,
    isSubFolder,
    selectedProjects = [],
    selectedOccupants = [],
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    folderType: isEditing ? folderData?.folderType || "" : "",
    parentId: isEditing ? folderData?.parentId || null : parentId,
    name: isEditing ? folderData?.name || "" : "",
    privacy: isEditing ? folderData?.privacy || 0 : 0,
    sortOrder: isEditing ? folderData?.sortOrder || 20 : 20,
    isSmart: isEditing ? folderData?.isSmart || 0 : 0,
    reportColumnId: isEditing ? folderData?.reportColumnId || "" : null,
    templateId: isEditing ? folderData?.templateId || templateId : templateId,
  });

  const { REACT_APP_REPORT_COLUMNS } = process.env;
  const reportColumn = JSON.parse(REACT_APP_REPORT_COLUMNS);

  const handleChange = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };


  useEffect(() => {
    if (!data.reportColumnId) {
      setData((prevData) => ({
        ...prevData,
        isSmart: 0,
      }));
    }
  }, [data.reportColumnId]);

  // Handle form submission for Add or Edit

  const handleSubmit = async () => {
    // const adjustedData =
    //   data.isSmart === 0 ? { ...data, reportColumnId: null } : data;

    const adjustedData = {
      ...data,
      reportColumnId: data.isSmart === 0 ? null : data.reportColumnId,
      projectIds: selectedProjects,
      occupantIds: selectedOccupants,
    };

    if (data.isSmart === 1 && isEmpty(data.reportColumnId)) {
      showAlert({
        title: "Error",
        text: "Column Name is required for Smart folders",
        icon: "error",
      });
      return;
    }
    const endpoint = isEditing
      ? `/v1/folder/${folderData.id}`
      : `/v1/addfolder/${templateId}`;
    setLoading(true);
    try {
      const response = await apiPost(endpoint, adjustedData);
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      setOpenModalView(false);
      setModalRowData(null);
      await fetchData();
    } catch (error) {
      showAlert({
        title: "Error",
        text: error?.response.data.message,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelModal = () => {
    setOpenModalView(false);
    setData({});
    setModalRowData(null);
  };

  const handleCancelModalisEditing = () => {
    setOpenModalView(false);
    setIsEditing(false);
    setData({});
    setModalRowData(null);
  };

  const AddModalData = () => {
    return (
      <div>
        <div style={{ marginTop: "20px" }}>
          <SC.LabelContainer>
            <SC.Label>
              Folder Name <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <InputField
                  name="name"
                  value={data?.name}
                  onChange={handleChange}
                  style={{ width: "340px" }}
                  required
                  // capitalize
                  maxLength={50}
                  regexType={regexTypes.exText}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>

          {isEditing ? (
            ""
          ) : (
            <SC.LabelContainer>
              <SC.Label>
                Folder Type <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <FolderTypeDropdown
                    name="folderType"
                    onChange={handleChange}
                    defaultValue={data.folderType}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>
          )}
          <SC.LabelContainer>
            {/* {isEditing &&
          (data.folderType == 3 ||
            data.folderType == 4 ||
            data.folderType == 7) ? (
            ""
          ) : (
            <SC.LabelContainer>
              <SC.Label>
                Folder Type <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <FolderTypeDropdown
                    name="folderType"
                    onChange={handleChange}
                    defaultValue={data.folderType}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>
          )}
          <SC.LabelContainer> */}
            <SC.Label>
              Folder Order <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <InputField
                  name="sortOrder"
                  type="number"
                  value={data?.sortOrder}
                  onChange={handleChange}
                  style={{ width: "98%" }}
                  capitalize
                  maxLength={7}
                  // regexType={regexTypes.numberWithDecimal}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
          {/* Gender Radio Group */}
          <Label label="Privacy">
            <RadioGroup
              row
              name="privacy"
              value={data?.privacy}
              onChange={(e) => handleChange("privacy", e.target.value)}
            >
              {privacyOption.map((option) => (
                <FormControlLabel
                  key={option.id}
                  value={option.id}
                  control={
                    <Radio
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 16,
                        },
                        "&.Mui-checked": {
                          color: "#EC810B",
                        },
                        margin: "0px 0px 0px 10px",
                      }}
                    />
                  }
                  label={option.label}
                />
              ))}
            </RadioGroup>
          </Label>
          {!(
            folderData?.folderType === allFolderType.Document &&
            folderData?.reportColumnId === reportColumn.ReleasedOn
          ) && (
            <>
              <Label label="Smart Folder ">
                <Switch
                  checked={data.isSmart}
                  onChange={(e) =>
                    handleChange("isSmart", e.target.checked ? 1 : 0)
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Label>

              {data.isSmart === 1 && (
                <>
                  <Label label="Column Name">
                    <SmartFolderColumnDropdown
                      name="reportColumnId"
                      onChange={handleChange}
                      defaultValue={data?.reportColumnId || undefined}
                      newItemLabel={"+ New Column"}
                      setSelectedData={(value) => {
                        handleChange("reportColumnId", value);
                      }}
                    />
                  </Label>

                  <span
                    style={{
                      fontSize: "12px",
                      padding: "0px 0px 0px 15px",
                      color: theme.colors.themeColor,
                    }}
                  >
                    Please select the column name for this smart folder to be
                    displayed in the OSS report.
                  </span>
                </>
              )}
            </>
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "20px",
          }}
        >
          <Button
            caption="Cancel"
            onClick={isEditing ? handleCancelModalisEditing : handleCancelModal}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />

          <Button
            caption={isEditing ? "Save" : "Add"}
            isLoading={loading}
            onClick={handleSubmit}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {openModalView &&
        (isEditing ? (
          <BulkActionView
            title={`Edit Folder `}
            openModal={openModalView}
            renderBodyConditionally={AddModalData}
            handleCloseModal={() => {
              setOpenModalView(false);
              setIsEditing(false);
              setData("");
              setModalRowData(null);
            }}
            sx={{
              minWidth: "550px",
            }}
          />
        ) : (
          <BulkActionView
            title={
              isSubFolder
                ? `Add Sub Folder to (${folderData?.name})`
                : "Add New Folder"
            }
            openModal={openModalView}
            renderBodyConditionally={AddModalData}
            handleCloseModal={() => {
              setOpenModalView(false);
              setData("");
              setModalRowData(null);
            }}
            sx={{
              minWidth: "550px",
            }}
          />
        ))}
    </>
  );
}

export default AddEditFolder;
